export const FILES_TO_ACCEPT = "image/*";

export interface InputOptions {
  capture?: "environment";
  "aria-label": string;
}
